import * as React from "react";
import type { SVGProps } from "react";
const SvgLayers04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m21.6 14.327-9.6 4.92-9.6-4.92M12 4.752l9.6 4.92-4.8 2.461-4.8 2.46-9.6-4.92z"
    />
  </svg>
);
export default SvgLayers04;
